import { FC, useEffect } from 'react';
// Import Styles
import styles from './MarkDownReader.module.scss';

interface Props {
    src: string;
    alt?: string;
    onClose: () => void;
}

const Lightbox: FC<Props> = ({ src, alt, onClose }) => {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div className={styles.lightbox} onClick={onClose} role="dialog" aria-modal="true">
            <button type="button" className={styles.lightboxClose} aria-label="Close preview" onClick={onClose}>
                ×
            </button>
            <img className={styles.lightboxImg} src={src} alt={alt} />
            {alt && <div className={styles.lightboxCaption}>{alt}</div>}
        </div>
    );
};

export default Lightbox;
